import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=050d3adc&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=050d3adc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050d3adc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('050d3adc')) {
      api.createRecord('050d3adc', component.options)
    } else {
      api.reload('050d3adc', component.options)
    }
    module.hot.accept("./Admin.vue?vue&type=template&id=050d3adc&scoped=true", function () {
      api.rerender('050d3adc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/admin/Admin.vue"
export default component.exports